import { ReactElement } from 'react';
import { Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { getStringifyUrlQueryString } from '~utils/router';
import { PATHS } from '~constants/paths';

import { AccessFeatureUpgradePlanButtonProps } from '../types';

const AccessFeatureUpgradePlanButtonShowPlan = ({
  variant = 'contained',
  size = 'small',
  color,
  className,
}: AccessFeatureUpgradePlanButtonProps): ReactElement => (
  <Button
    variant={variant}
    size={size}
    color={color}
    className={className}
    component={RouterLink}
    to={getStringifyUrlQueryString({
      url: PATHS.CONFIG.SUBSCRIPTIONS.BASE,
      query: {
        currentTab: 'plans-packages',
      },
    })}
  >
    Ver Planes
  </Button>
);

export default AccessFeatureUpgradePlanButtonShowPlan;
